import bsCustomFileInput from 'bs-custom-file-input';
import AOS from 'aos';

import * as Routes from './routes';
import 'select2'
import 'magnific-popup/dist/jquery.magnific-popup'
import 'summernote/dist/summernote-bs4'
import 'summernote/dist/lang/summernote-pt-BR'

do ->
  'use strict'

  $(document).on 'turbolinks:load', ->
    # LOAD TOOLTIPS
    $('[data-toggle="tooltip"]').tooltip()
    $('[data-toggle="popover"]').popover()

    # MENU TOGGLE
    $('#menu-toggle').click (e) ->
      e.preventDefault();
      $('#wrapper').toggleClass 'toggled'
      return

    # SELECT2
    $.fn.select2.defaults.set('theme', 'bootstrap4');
    $.fn.select2.defaults.set('language', 'pt-BR');
    $('.select2').select2();

    wireTipoAssuntoFiltro = (formSelector) ->
      filterForm = $(formSelector)
      return unless filterForm.length

      tipoSelect = filterForm.find('select[name="tipo_processo_id"]')
      assuntoSelect = filterForm.find('select[name="assunto_processo_id"]')
      return unless tipoSelect.length && assuntoSelect.length

      placeholderText = assuntoSelect.find('option[value=""]').first().text() or 'TODOS OS ASSUNTOS'

      buildPlaceholder = ->
        new Option(placeholderText, '', false, false)

      resetAssunto = (disable = true) ->
        assuntoSelect.find('option').remove()
        assuntoSelect.append(buildPlaceholder())
        assuntoSelect.val('').trigger('change.select2')
        assuntoSelect.prop('disabled', disable).trigger('change.select2')

      populateAssuntos = (options) ->
        assuntoSelect.find('option').remove()
        assuntoSelect.append(buildPlaceholder())
        if Array.isArray(options)
          for item in options
            continue unless item?.id? && item?.nome?
            option = new Option(item.nome, item.id, false, false)
            assuntoSelect.append(option)
        assuntoSelect.prop('disabled', false)
        assuntoSelect.trigger('change.select2')

      if tipoSelect.val()
        assuntoSelect.prop('disabled', false).trigger('change.select2')
      else
        resetAssunto()

      tipoSelect.off('change.assuntosFiltro').on 'change.assuntosFiltro', ->
        tipoId = $(this).val()
        resetAssunto()
        return unless tipoId

        $.getJSON(Routes.assuntos_processos_path(tipoId)).done((data) ->
          populateAssuntos(data)
        ).fail((xhr) ->
          console.error('Nao foi possivel carregar os assuntos para o tipo selecionado.', xhr)
          resetAssunto()
        )

    wireTipoAssuntoFiltro('#checklist-documentos-filter')
    wireTipoAssuntoFiltro('#formularios-personalizados-filter')
    wireTipoAssuntoFiltro('#processos-workflows-filter')

    # EDITOR SUMMERNOTE
    global.default_summernote = ->
      $('.summernote').summernote({
        disableDragAndDrop: true,
        height:             150,
        lang:               'pt-BR',
        toolbar:            [
          ['misc', ['undo', 'redo']],
          ['style', ['style', 'fontsize']],
          ['font', ['bold', 'italic', 'underline', 'clear']],
          ['style', ['forecolor', 'backcolor']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['insert', ['table', 'hr', 'link']]
        ]
        callbacks: onChange: (contents) ->
          if $('.summernote').summernote('isEmpty')
            $('.summernote').next('.note-editor').find('.note-editable').html ''
          return
      });

    global.default_summernote()

    # FILE INPUT DYNAMIC
    bsCustomFileInput.init()

    # IMAGE POPUP
    $('.image-popup').magnificPopup({
      type: 'image',
      zoom: {
              enabled:  true,
              duration: 300
            }
    });

    # ANIMATE ON SCROLL
    AOS.init();

    return

  # END BLOCK SCRIPT
  return
